var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Col } from "react-bootstrap";
import { EdALinkButton, } from "@frameworks/web/components/generic/edbutton/edButton";
import { useSelector } from "react-redux";
import { accountDetails } from "@salesdi";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
var Activation = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var _h = __read(React.useState(""), 2), userId = _h[0], setUserId = _h[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var getUserid = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = setUserId;
                    return [4 /*yield*/, accountDetails.getSalesuserId()];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        if (selectedAcount && (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode))
            getUserid();
    }, [selectedAcount]);
    return (React.createElement("section", { id: "activation" },
        React.createElement("label", { className: "DMSanBold_18_700 txt_blackOne1 heading-padding" },
            "Activation",
            React.createElement("i", { className: "edel-icon-Activation fw-bolder ms-2" })),
        React.createElement(Col, null,
            React.createElement("div", { className: "d-grid" },
                React.createElement("label", { className: "DMSanN_14_400 txt_secondary-gray" },
                    "1st Payment Date",
                    React.createElement("div", { className: "DMSanN_16_400 txt_blackOne1" }, addDashIfNullOrUndefined((_a = props === null || props === void 0 ? void 0 : props.clientLifeCycle) === null || _a === void 0 ? void 0 : _a.fristpayingdate))),
                React.createElement("label", { className: "DMSanN_14_400 txt_secondary-gray" },
                    "1st Investment Date",
                    React.createElement("div", { className: "DMSanN_16_400 txt_blackOne1" }, addDashIfNullOrUndefined((_b = props === null || props === void 0 ? void 0 : props.clientLifeCycle) === null || _b === void 0 ? void 0 : _b.firstinvestmentdate))),
                React.createElement("label", { className: "DMSanN_14_400 txt_secondary-gray" },
                    "Last Profiling Date",
                    React.createElement("div", { className: "DMSanN_16_400 txt_blackOne1" }, addDashIfNullOrUndefined((_c = props === null || props === void 0 ? void 0 : props.clientLifeCycle) === null || _c === void 0 ? void 0 : _c.lastprofilingdate))),
                React.createElement("label", { className: "DMSanN_14_400 txt_secondary-gray" },
                    "Activation Tat",
                    React.createElement("div", { className: "DMSan_16_700 txt-midnight-blue", style: { color: (_d = props === null || props === void 0 ? void 0 : props.clientLifeCycle) === null || _d === void 0 ? void 0 : _d.activationtatcolor } },
                        addDashIfNullOrUndefined((_e = props === null || props === void 0 ? void 0 : props.clientLifeCycle) === null || _e === void 0 ? void 0 : _e.activationtat),
                        " ",
                        "Days")),
                React.createElement("label", { className: "DMSanN_14_400 txt_secondary-gray" },
                    "Total Profile (%)",
                    React.createElement("div", { className: "DMSanN_16_400 txt_blackOne1 d-flex align-items-baseline" },
                        addDashIfNullOrUndefined((_f = props === null || props === void 0 ? void 0 : props.clientLifeCycle) === null || _f === void 0 ? void 0 : _f.profilingper),
                        "\u00A0",
                        ((_g = props === null || props === void 0 ? void 0 : props.clientLifeCycle) === null || _g === void 0 ? void 0 : _g.profilingper) && (React.createElement(EdALinkButton, { target: "_blank", btnTyp: "midnight-blue", LinkHref: process.env.VIEW_PROFILE_IMAGE +
                                "?AcCode=".concat(selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode, "&LoginId=").concat(userId), value: "View", className: "no_bg txt-midnight-blue text-decoration-underline" }))))))));
};
export default Activation;
